import gql from 'graphql-tag';

export const SIGNIN_MUTATION = gql`
  mutation signIn($email: String!, $password: String!) {
    signIn(email: $email, password: $password) {
      id
      email
      firstName
      lastName
      isSuperUser
    }
  }
`;

export const RESET_PASSWORD_MUTATION = gql`
  mutation sendResetEmail($email: String!) {
    sendResetEmail(email: $email) {
      id
    }
  }
`;

export const LOG_OUT = gql`
  mutation logOut {
    logOut {
      ok
    }
  }
`;
